import { Component, OnInit, OnDestroy } from '@angular/core';
import { LiferayService } from '../../../services/liferay/liferay.service';
import { ERROR_PAGE_DEFAULT_CONTENT, LIFERAY_WEB_CONSTANT } from '../../../utils/liferay.constant';
import { RouterService } from '../../../services/router/router.service';
import { IErrorPageContent } from '../../../services/liferay/liferay.interface';
import { catchError, of, Subject, takeUntil } from 'rxjs';
import { trackByIndex } from '../../../utils/helper';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit, OnDestroy {
  public pageWebContent: IErrorPageContent[] | undefined;
  public pageContent: IErrorPageContent[] | undefined;
  cleaner$: Subject<void> = new Subject();
  trackByIndex = trackByIndex;
  constructor(private lifeRayService: LiferayService, private routerService: RouterService) { }

  ngOnInit(): void {
    this.getErrorPageContent();
  }


  getErrorPageContent(): void {
    let content = LIFERAY_WEB_CONSTANT.error_content;
    this.lifeRayService
      .getWebContent<IErrorPageContent[]>(content.type, content.id)
      .pipe(
        takeUntil(this.cleaner$),
        catchError(() => of({ value: ERROR_PAGE_DEFAULT_CONTENT } as any))
      )
      .subscribe(data => {
        this.pageWebContent = data.value;
        if (this.pageWebContent) {
          this.pageContent = this.pageWebContent;
        } else {
          this.pageContent = ERROR_PAGE_DEFAULT_CONTENT;
        }
      });
  }  

  navigateToHome(): void {
    window.location.href = 'https://www.cinchhomeservices.com/';
  }

  ngOnDestroy(): void {
    this.cleaner$.complete();
  }
}
